import { Avatar, Button, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { useState } from "react";
import { Account } from "mdi-material-ui";
import { ILogoutRequiredFormValues } from "../_interfaces/ILogoutRequiredFormValues";
import FormLoadingSpinner from "../../../components/Organization/VolunteerOpportunities/FormLoadingSpinner";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            position: 'relative'
        },
        prompt: {
            marginBottom: theme.spacing(2),
            maxWidth: 800,
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        avatar: {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
            width: '75px',
            height: '75px',
            margin: '16px auto'
        },
        accountInformation: {
            margin: theme.spacing(2, 0, 3)
        },
    }),
);

interface LogoutRequiredFormProps {
    values: ILogoutRequiredFormValues;
    onChange: (patch: Partial<ILogoutRequiredFormValues>) => void;
    onSubmit: (override?: Partial<ILogoutRequiredFormValues>) => void;
    isSubmitting?: boolean;
    error?: string;
    fieldErrors?: Partial<Record<keyof ILogoutRequiredFormValues, string>>;
}

export const LogoutRequiredForm: React.FC<LogoutRequiredFormProps> = ({
    values,
    onChange,
    onSubmit,
    isSubmitting,
    error,
    fieldErrors
}) => {

    /********** State **********/

    const getFormId = () => {
        return `form-logout-required-${Date.now()}-${Math.random()}`;
    }

    const [formId] = useState(() => getFormId());

    /********** React hooks **********/

    const classes = useStyles();

    /********** Event handlers **********/

    const onLogoutClicked = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        onSubmit();
    }

    /********** Render **********/

    return (
        <form onSubmit={onLogoutClicked} noValidate autoComplete="off" id={formId} className={classes.form}>
            {values.loading ? <FormLoadingSpinner /> : undefined}
            <Avatar className={classes.avatar}>
                <Account fontSize='large' />
            </Avatar>
            <Typography variant="h4">
                You're currently logged in as:
            </Typography>
            <div className={classes.accountInformation}>
                <Typography variant="h6">
                    {values.currentUserName}
                </Typography>
                <Typography variant="h6">
                    {values.currentUserEmail}
                </Typography>
            </div>
            <Typography variant="h6" className={classes.prompt}>
                {values.prompt}
            </Typography>
            <Button color="primary" variant="contained" type="submit" form={formId} size="large" disabled={isSubmitting}>
                Logout
            </Button>
        </form>
    );
};